import React from 'react'
import { Page } from '@moonpig/web-core-app'
import { Routes } from '@moonpig/web-core-routing'
import { Region } from '@moonpig/web-core-types'

import { useExperimentBoolean } from '@moonpig/web-core-eppo/browser'
import { AuthenticationWizard } from '../../components/AuthenticationWizard'
import { LoginPageContainer } from '../../components/LoginPageContainer'

type PageProps = {
  region: Region
  returnUrl?: string
  source?: string
  magicLinkToken?: string
  magicLinkAuthRequired?: boolean
  socialLoginCookie?: string
  url: string
  pageOptions?: { tracking: { type: string } }
}

export const LoginPage: Page<PageProps, Routes['login']> = props => {
  const featureCustomCodeInput = useExperimentBoolean(
    'customer-auth-custom-code-input',
    { fallback: false },
  )
  const flags = { 'customer-auth-custom-code-input': featureCustomCodeInput }
  return (
    <LoginPageContainer flags={flags} url={props.url} region={props.region}>
      <AuthenticationWizard flags={flags} {...props} />
    </LoginPageContainer>
  )
}

LoginPage.layout = 'auth'
LoginPage.shouldDangerouslySkipMagicLinkRedirect = true

LoginPage.getInitialProps = async ({
  region,
  query,
  getCookie,
  environment,
  path,
}): Promise<PageProps> => {
  return {
    region,
    returnUrl: query.returnUrl,
    magicLinkToken: query.cst_mlt,
    magicLinkAuthRequired: query.cst_mlt_auth_required,
    source: query.source,
    socialLoginCookie: getCookie('mnpg_social_login'),
    url: environment.hostUrl + path,
    pageOptions: {
      tracking: {
        type: 'account',
      },
    },
  }
}
